import React from 'react';
import { Row, Col, Button, Alert, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Translate, translate, getUrlParameter, Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { IRootState } from 'app/shared/reducers';
import { handleAddPassword, reset } from '../user.reducer';
import { SUCCESS, ERROR } from 'app/config/constants';
import MessageModal from 'app/shared/message/message-modal';

export interface IAuthAddPasswordModalProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
}

export interface IAuthAddPasswordModalState {
  visible: boolean;
  color: string;
  message: string;
  showMessage: boolean;
}
export class AuthAddPasswordModal extends React.Component<IAuthAddPasswordModalProps, IAuthAddPasswordModalState> {
  state: IAuthAddPasswordModalState = {
    visible: false,
    color: 'danger',
    message: '',
    showMessage: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.response !== nextProps.response) {
      const { response } = nextProps;
      if (response && response.status === 'SUCCESS') {
        this.setState({
          showMessage: true
        });
        this.props.handleClose();
        let timerId = setTimeout(() => {
          this.setState({
            showMessage: false
          });
        }, 2000);
      } else if (response && response.status) {
        this.setState({
          visible: true,
          color: 'danger',
          message: response.message && response.message !== ERROR ? response.message : translate('register.messages.error.addfail')
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleValidSubmit = (event, values) => {
    let password = values.newPassword;
    if (password && password.indexOf(' ') > -1) {
      this.setState({
        visible: true,
        color: 'danger',
        message: 'Mật khẩu không được chứa khoảng trắng.'
      });
    } else {
      this.props.handleAddPassword(values.newPassword);
    }
    event.preventDefault();
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  render() {
    return (
      <div>
        <MessageModal
          type={SUCCESS}
          showModal={this.state.showMessage}
          message={'Chúc mừng bạn đã thêm phương thức xác thực thành công.'}
        />
        <Modal
          className="hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.props.handleClose}
          backdrop="static"
          centered={window.location === window.parent.location}
        >
          <ModalHeader toggle={this.props.handleClose} />
          <ModalBody className="padding-modal-body">
            <Row className="justify-content-center bodyModal">
              <Col md="12">
                <h2 className="text-center font-weight-bold" id="register-title">
                  <Translate contentKey="password.titleAddAuth">Registration</Translate>
                </h2>
                <h5 className="text-center txtContent">
                  <Translate contentKey="password.txtContent" />
                </h5>
                <p style={{ marginTop: '10px', textAlign: 'center' }}>
                  Tài khoản: <strong>{this.props.userProfile.fullname}</strong>{' '}
                </p>
                <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
                  {this.state.message}
                </Alert>
                <AvForm id="password-form" style={{ marginTop: '7%', marginBottom: '5%' }} onValidSubmit={this.handleValidSubmit}>
                  <AvField
                    name="newPassword"
                    label={translate('global.form.password.label')}
                    placeholder={translate('global.form.password.placeholder')}
                    type="password"
                    validate={{
                      required: { value: true, errorMessage: translate('global.messages.validate.newpassword.required') },
                      pattern: {
                        value: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,}$',
                        errorMessage: translate('global.messages.validate.newpassword.strengthmessage')
                      },
                      minLength: { value: 8, errorMessage: translate('global.messages.validate.newpassword.minlength') },
                      maxLength: { value: 30, errorMessage: translate('global.messages.validate.newpassword.maxlength') }
                    }}
                  />
                  <AvField
                    name="confirmPassword"
                    label={translate('global.form.confirmpassword.label')}
                    placeholder={translate('global.form.confirmpassword.placeholder')}
                    type="password"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: translate('global.messages.validate.confirmpassword.required')
                      },
                      minLength: { value: 8, errorMessage: translate('global.messages.validate.confirmpassword.minlength') },
                      maxLength: { value: 30, errorMessage: translate('global.messages.validate.confirmpassword.maxlength') },
                      match: {
                        value: 'newPassword',
                        errorMessage: translate('global.messages.error.dontmatch')
                      }
                    }}
                  />
                  <Button className="btn-register" type="submit" block>
                    THÊM MẬT KHẨU
                    {/* <Translate contentKey="password.form.btnSave">Register</Translate> */}
                  </Button>
                </AvForm>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  response: storeState.userInfo.resAddPassword,
  userProfile: storeState.userInfo.userProfile
});
const mapDispatchToProps = { handleAddPassword, reset };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthAddPasswordModal);
